import { GTM_EVENTS } from 'hooks/useGoogleTracking'

export const subscriptions = [
  {
    name: 'Basic',
    title: 'Annual',
    description: 'Access to premium features of the NextRetreat app for 12 months.',
    price: 89,
    finalPrice: 89 * 12,
    interval: 'month',
    intervalCount: 1,
    id: process.env.REACT_APP_ANNUAL_PRICE,
    checked: [
      'All NextRetreat features',
      'Full venue inventory',
      'Unlimited access (number of team members, origin locations, trips)',
    ],
    gtmEventName: GTM_EVENTS.packageBuyAnnual,
  },
  {
    name: 'Basic',
    title: 'Quarterly',
    description: 'Access to premium features of the NextRetreat app for 3 months.',
    price: 99,
    finalPrice: 99 * 3,
    interval: 'month',
    intervalCount: 1,
    id: process.env.REACT_APP_QUARTERLY_PRICE,
    checked: [
      'All NextRetreat features',
      'Full venue inventory',
      'Unlimited access (number of team members, origin locations, trips)',
    ],
    gtmEventName: GTM_EVENTS.packageBuyQuarterly,
  },
  {
    name: 'Basic',
    title: 'Monthly',
    description: 'Access to premium features of the NextRetreat app for 1 month.',
    price: 119,
    finalPrice: 119,
    interval: 'month',
    intervalCount: 1,
    id: process.env.REACT_APP_MONTHLY_PRICE,
    checked: [
      'All NextRetreat features',
      'Full venue inventory',
      'Unlimited access (number of team members, origin locations, trips)',
    ],
    gtmEventName: GTM_EVENTS.packageBuyMonhtly,
  },
]
